import autobind from '@lskjs/autobind';

export default autobind;
